module.exports = __webpack_public_path__ + "img/skills-hammerdin-2.ab98adce.png";